import React, { useEffect, useCallback } from "react";
import {
  Typography,
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  CircularProgress
} from "@material-ui/core";
import FeedComponent from "./components/FeedComponent";
import AddIcon from "@material-ui/icons/Add";
import { useState } from "react";
import { useDropzone } from "react-dropzone";
import UploadIcon from "@material-ui/icons/CloudUpload";
import { Editor } from "react-draft-wysiwyg";
import { EditorState ,convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { AddPost, FetchPosts } from './api'

const _data = [
  {
    avatar:
      "https://images.unsplash.com/photo-1548048876-54a717fa3f8c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxjb2xsZWN0aW9uLXRodW1ibmFpbHx8NDM4OTU4M3x8ZW58MHx8fHw%3D&auto=format&fit=crop&w=420&q=60",
    img: "https://webartdevelopers.com/blog/wp-content/uploads/2021/01/full-screen-carousel-with-navbar.jpg",
  },
  {
    avatar:
      "https://images.unsplash.com/photo-1513956589380-bad6acb9b9d4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fGJveXN8ZW58MHx8MHx8&w=1000&q=80",
    img: "https://wowslider.com/sliders/demo-69/data1/images/mountainlandscape.jpg",
  },
  {
    avatar:
      "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/0177cd0d-ed6c-4f92-8e00-a4138579d909/de927r6-9daa8787-a752-4ac0-aaf6-5f19fd97821a.jpg/v1/fill/w_1280,h_1536,q_75,strp/boy_portrait_by_uyenthainguyen_de927r6-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTUzNiIsInBhdGgiOiJcL2ZcLzAxNzdjZDBkLWVkNmMtNGY5Mi04ZTAwLWE0MTM4NTc5ZDkwOVwvZGU5MjdyNi05ZGFhODc4Ny1hNzUyLTRhYzAtYWFmNi01ZjE5ZmQ5NzgyMWEuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.OiGxcGzb0hQ28DI3uPZbOuvCLpfiWKH9_xhaQhP1KkI",
    img: "https://hueandhatchet.com/wp-content/uploads/2020/10/Clarity-Slider-Header-1024x683.jpg",
  },
  {
    avatar:
      "https://cdn.pixabay.com/photo/2021/01/04/10/41/icon-5887126_960_720.png",
    img: "https://ipt.imgix.net/200575/x/0/iceland-photo-tours10.jpg?ar=1.91%3A1&w=1200&fit=crop",
  },
];
export function FeedsPage() {
  const [DialogState, setDialogState] = useState(false);
  const handleDialogClose = () => {
    setDialogState(false);
  };

  const [form, setForm] = useState({
    title: '',
    discription: '',
    image: null,
    isLoading: false
  })

  const [posts, setPosts] = useState([]);

  const [loading, setLoading] = useState(false);

  const [editorState, onEditorStateChange] = useState(EditorState.createEmpty());

  
  const { acceptedFiles ,getRootProps, getInputProps, isDragActive } = useDropzone();
  const [snack, setSnack] = useState(()=>({
    message: '',
    open: false
  }))
  
  useEffect(()=>{
    setForm((pre)=>({
      ...pre,
      image: acceptedFiles[0]
    }))
  },[acceptedFiles])
  useEffect(()=>{
    let text = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    // console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    setForm((pre)=>({
      ...pre,
      discription: text
    }))
  }, [editorState])
  useEffect(()=>{
    console.log(form);
  },[form])


  const handleAddPost = async () => {

    if(form.title == ''){
      setSnack((pre)=>({
        ...pre,
        open: true,
        message: 'Please Enter title'
      }))
      return;
    }
    if(form.discription == '' || form.discription == '<p></p>\n'){
      setSnack((pre)=>({
        ...pre,
        open: true,
        message: 'Please Enter Discription'
      }))
      return;
    }
    if(form.image == null){
      setSnack((pre)=>({
        ...pre,
        open: true,
        message: 'Please Select Image'
      }))
      return;
    }
    setForm((pre)=>({
      ...pre,
      isLoading: true
    }));

    let formData = new FormData();
    formData.append('title', form.title)
    formData.append('discription', form.discription)
    formData.append('image', form.image)

    let res = await AddPost(formData);

    setSnack((pre)=>({
      ...pre,
      open: true,
      message: res.message   
    }))

    setForm(()=>({
      title: '',
      discription: EditorState.createEmpty(),
      image: null,
      isLoading: false
    }))
    setDialogState(false);
    fetchAllPost();
    console.log(res);
  }

  const fetchAllPost = async () => {
    setLoading(true);

    let res = await FetchPosts();
    setPosts(res.data.newsfeeds);

    console.log(res.data);

    setLoading(false)
  }

  useEffect(()=>{
    fetchAllPost();
  },[])

  

  return (
    <div>
      <Snackbar
        open={snack.open}
        autoHideDuration={2000}
        message={snack.message}
        onClose={()=>{
          setSnack(()=>({
            open: false,
            message: ""
          }))
        }}
      />
      <div className="col-sm-12 mb-5 d-flex justify-content-between">
        <Typography variant="h4" className="font-weight-bold">
          Posts
        </Typography>
        <Grid item>
          <Button
            color="primary"
            // className={classes.button}
            onClick={() => setDialogState(true)}
            startIcon={<AddIcon style={{ fontSize: 25 }} />}
          >
            <Typography className="px-3" variant="h6">
              Add New Post
            </Typography>
          </Button>
        </Grid>
        <Dialog
          open={DialogState}
          onClose={handleDialogClose}
          aria-labelledby="form-dialog-title"
          maxWidth="sm"
          fullWidth="100%"
        >
          <DialogTitle id="form-dialog-title">
            <Typography variant="h6">ADD NEW POST</Typography>
          </DialogTitle>
          <DialogContent>
            <input
              className="form-control form-control-solid h-auto py-5 px-6 my-3"
              autoFocus
              margin="dense"
              placeholder="Title"
              value={form.title}
              onChange={(e)=> setForm((pre)=>({...pre, title: e.target.value}))}
            />
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="mt-5 mb-5"
              editorClassName="AtEditor"
              onEditorStateChange={onEditorStateChange}
            />
            <Grid item className="mt-4">
              <div {...getRootProps()}>
                <input {...getInputProps({ multiple: false })} />
                <Button style={{ color: "grey" }} startIcon={<UploadIcon />}>
                  Upload Document
                </Button>
              </div>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid
              className="px-5 mb-4"
              container
              direction="row"
              justify="space-between"
            >
              <Grid item>
                <Button
                  size="large"
                  // onClick={handleDialogClose}
                  // variant={"contained"}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  size="large"
                  // onClick={handleAddClient}
                  color="secondary"
                  variant={"contained"}
                  className="px-10"
                  onClick={handleAddPost}
                  disabled={form.isLoading}
                >
                  {/* {addClientLoader ? (
                      <CircularProgress
                        size="20px"
                        style={{ color: "#ffffff" }}
                      />
                    ) : ( */}
                  <Typography>Add</Typography>
                  {/* )} */}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
      <div>
        {loading ? 
          <div style={{textAlign: 'center'}}>
            <CircularProgress />
          </div>
        :
          posts.length > 0 ?
          posts.map((x) => (
            <FeedComponent feed={x} fetchAllPost={fetchAllPost} snack={setSnack}/>
          )) :
          <div style={{textAlign: 'center'}}>
            <p>No Posts are avaiable</p>
          </div>
        }
        
      </div>
    </div>
  );
}
